import { Component, Input, Output, EventEmitter } from '@angular/core';
import { SelectItem } from 'primeng/primeng';
import { BaseStepComponent } from "../../../base/base-step.component";

@Component({
    selector: 'evento-prestacao-conta-etapa2',
    templateUrl: './evento-prestacao-conta-etapa2.component.html',
})
export class CrudEventoPrestacaoContaEtapa2Component extends BaseStepComponent {

    @Input() validateForm: any = false;
    @Output() validateFormChange = new EventEmitter<any>();
    @Input() listaUf: SelectItem[] = [];
    @Input() listaDiasSemana: any[] = [];
    @Input() listaPais: SelectItem[] = [];
    @Input() listaMunicipios: SelectItem[] = [];

    @Output() stepObject: EventEmitter<any> = new EventEmitter<any>(true);
    listaCidades: SelectItem[] = [];
    requiredValidator: boolean = false;
    init() {
        this.cadastro.get('id_uf').valueChanges.subscribe(id_uf => {
            this.service.ListarTodos('cidade', { id_estado: id_uf }).subscribe(data => {
                this.listaCidades = data;
            })
        });
        this.cadastro.get('id_pais').valueChanges.subscribe(id => {
            this.requiredValidator = id === 31 ? true : false
        });
    }
}


// WEBPACK FOOTER //
// ./src/app/evento-prestacao-conta/crud/etapas/evento-prestacao-conta-etapa2.component.ts